import { render, staticRenderFns } from "./SiteAction.vue?vue&type=template&id=4adfb3c8"
import script from "./SiteAction.vue?vue&type=script&lang=js"
export * from "./SiteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports